module.exports = __webpack_public_path__ + "static/img/4.e23b334.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/register/ovulation/4.png
// module id = p5kA
// module chunks = 1